/* eslint-disable consistent-return */
import React from 'react';
import Ola from './datelle-ola';
import CargaManual from './detalle-carga-manual';
import Eurovips from './detalle-eurovips';
import AllSeasons from './detalle-allseasons';
import Pythagoras from './detalle-pythagoras';
import Amichi from './detalle-amichi';

const DetalleRouter = (props) => {
  const proveedores = {
    '1': (<CargaManual {...props} />),
    '2': (<Ola {...props} />),
    '3': (<AllSeasons {...props} />),
    '4': (<Eurovips {...props} />),
    '5': (<Pythagoras {...props} />),
    '6': (<Pythagoras {...props} />),
    '7': (<Pythagoras {...props} />),
    '8': (<Pythagoras {...props} />),
    '9': (<Pythagoras {...props} />),
    '10': (<Amichi {...props} />),
    '11': (<Pythagoras {...props} />),
  };
  try {
    return (
      <div>
        {(props.paquete !== undefined || props.paquete.proveedorId !== undefined) ? proveedores[parseInt(props.paquete.proveedorId)] : '' }
      </div>
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export default DetalleRouter;

